const { log } = require('@virtual-peaker/vp-common').vpLog;

export {
  log,
};
